// extracted by mini-css-extract-plugin
export default {"galleryPage":"gallery-page_galleryPage__nhlaD"};